export const MIXPANEL_SAVED_CONTENT_ADD = 'saved_content_add';
export const MIXPANEL_SAVED_CONTENT_REMOVE = 'saved_content_remove';
